exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-group-family {\n  margin-bottom: 1rem;\n  height: 75px;\n  border: 1px solid transparent;\n  width: 93%;\n  margin-left: 16px; }\n  .form-group-family .form-family .family-selection {\n    padding-left: 10px; }\n    .form-group-family .form-family .family-selection .family-select {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center;\n      width: 100%;\n      padding: 5px 0px; }\n      .form-group-family .form-family .family-selection .family-select .family-text {\n        font-family: \"Open Sans\";\n        font-weight: 300;\n        color: #575757;\n        padding-left: 10px; }\n      .form-group-family .form-family .family-selection .family-select .family-checkbox {\n        display: block !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--4-2!/root/social-native/socialnative-web/node_modules/sass-loader/lib/loader.js!../scss/form/component/form_family.scss
// module id = 2422
// module chunks = 69